const setContactForm = () => {
  const form = document.querySelector('.p-contact_form__form'),
    productType = form?.querySelector('.js-form-product-type select'),
    contactType = form?.querySelectorAll('.js-form-contact-type input[type=radio]');
  if (!form || !productType || !contactType.length) return false;

  const params = new URL(document.location).searchParams,
    type = params.get("type");

  if (type && type == 'logic') {
    form.querySelectorAll('select[name="商品の種類"] option').forEach(option => {
      if (option.textContent === 'スーパーペイントロジック') {
        option.selected = true;
      }
    })
  }

  const setPlanItems = (key) => {
    const labels = {
      pakurosu: ['ペットスケルトン', 'メイルプラザ', 'ロバの耳'],
      logic: ['ペンロジ大喜利', '人気キャラクターランキング'],
    }

    let html = ``;

    if (key) {
      labels[key].forEach((label, index) => {
        html += `
                          <span class="c-form-radio__item">
                            <label>
                              <input type="radio" name="応募する企画" value="${label}" ${index === 0 ? 'checked' : ''}>
                              <span>${label}</span>
                            </label >
                          </span > `;
      });
    }

    form.querySelector('.js-form-plan').innerHTML = html;
  }

  const getPlanKey = () => {
    const selectedProductType = productType.options[productType.selectedIndex];
    const selectedProductCategory = selectedProductType.parentElement;
    if (selectedProductCategory.tagName !== "OPTGROUP") return false;

    return selectedProductCategory.label === 'パクロス' ? 'pakurosu' : 'logic';
  }

  const controlDisplayFormItems = (type) => {
    const targets = form.querySelectorAll('.js-form-switch-item');

    targets.forEach(target => {
      target.style.display = type === 'show' ? 'flex' : 'none';
      target.querySelectorAll('input').forEach(input => {
        input.disabled = type !== 'show';
      })
    })
  }

  const setFormItems = () => {
    const selectedContactType = form.querySelector('input[name="お問い合わせの種類"]:checked').value;

    if (selectedContactType === '投稿募集') {
      controlDisplayFormItems('show');
      const planKey = getPlanKey(selectedContactType);
      setPlanItems(planKey);
    } else {
      controlDisplayFormItems('hide');
    }
  }

  [productType, ...contactType].forEach(target => {
    target.addEventListener('change', function (e) {
      if (this.name === '商品の種類') {
        const recruitment = form.querySelector('input[name="お問い合わせの種類"][value="投稿募集"]'),
          contact = form.querySelector('input[name="お問い合わせの種類"][value="お問い合わせ"]');
        if (this.value !== 'クロスワードパクロス' && this.value !== 'スーパーペイントロジック') {
          contact.checked = true;
          recruitment.closest('.c-form-radio__item').style.display = 'none';
        } else {
          recruitment.checked = true;
          recruitment.closest('.c-form-radio__item').style.display = 'block';
        }
      }

      setFormItems();
    });
  })

  setFormItems();


  form.querySelector('input[type="file"]')?.addEventListener("change", function () {
    const file = this.files[0];
    if (file) {
      const allowedExtensions = ["jpg", "jpeg", "JPG", "JPEG", "png", "PNG", "gif", "GIF"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        alert("対応ファイル形式は .jpg, .png, .gif のみです");
        this.value = "";
      }
    }
  });
};

export default setContactForm;